import {Directive, OnDestroy} from '@angular/core';
import {Subject} from 'rxjs';

@Directive()
// tslint:disable-next-line:directive-class-suffix
export abstract class UnsubscribingComponent implements OnDestroy {
  protected unsubscribe = new Subject<void>();

  public ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
